import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from '../context/LocationContext';

export default function LocationPicker() {
  const { location, setLocation, current, LOCATIONS } = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Pill button */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 14px',
          borderRadius: 20,
          border: '1px solid #E5E7EB',
          background: '#fff',
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 500,
          fontFamily: 'Inter, sans-serif',
          color: '#111827',
          transition: 'border-color 150ms ease, box-shadow 150ms ease',
          ...(open ? { borderColor: '#F07EA0', boxShadow: '0 0 0 3px rgba(240,126,160,0.15)' } : {}),
        }}
      >
        <span style={{ fontSize: 14 }}>&#128205;</span>
        <span>{current.label}</span>
        <span style={{ fontSize: 10, color: '#9CA3AF', marginLeft: 2 }}>&#9662;</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff',
            border: '1px solid #E5E7EB',
            borderRadius: 12,
            boxShadow: '0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06)',
            minWidth: 200,
            padding: '4px 0',
            zIndex: 100,
            animation: 'fade-in 100ms ease',
          }}
        >
          {LOCATIONS.map(loc => (
            <button
              key={loc.key}
              onClick={() => { setLocation(loc.key); setOpen(false); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                width: '100%',
                padding: '10px 14px',
                border: 'none',
                background: location === loc.key ? '#FDF2F7' : 'transparent',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: location === loc.key ? 600 : 400,
                color: location === loc.key ? '#F07EA0' : '#111827',
                fontFamily: 'Inter, sans-serif',
                transition: 'background 100ms ease',
              }}
              onMouseEnter={e => { if (location !== loc.key) e.currentTarget.style.background = '#F9FAFB'; }}
              onMouseLeave={e => { if (location !== loc.key) e.currentTarget.style.background = 'transparent'; }}
            >
              {loc.key === 'all' ? (
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#9CA3AF' }} />
              ) : (
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: loc.color }} />
              )}
              <span style={{ flex: 1, textAlign: 'left' }}>{loc.label}</span>
              {location === loc.key && <span style={{ color: '#F07EA0', fontSize: 14 }}>&#10003;</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
